import { GsResponse, RawValidResponse, toGsResponse } from '../../goodstack'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { GivingProfile } from '@percent/workplace-giving/context/auth/authContext/AuthContext.types'

type updateOrRemoveGivingProfileSecondaryEmailProps = {
  secondaryEmail: string | null
}

export const updateOrRemoveGivingProfileSecondaryEmail: MutationFn<
  updateOrRemoveGivingProfileSecondaryEmailProps,
  GsResponse<GivingProfile>
> = async (client, { secondaryEmail }) => {
  const res = await client.patch<RawValidResponse<GivingProfile>>(
    `v1/account/giving/profile`,
    { secondaryEmail },
    {
      withCredentials: true
    }
  )

  return toGsResponse(res.status, res.data)
}
